import React from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../../store/indexStore";
import AddMenuModel from "./AddMenuModel";
import { Button } from "src/Components/ui/button";
import { Plus, UtensilsCrossed } from "lucide-react";
import Iterator from "src/Components/utils/Iterator";
import { MenuCard, MenuCardLoading } from "src/Components/Cards/MenuCard";
import Visibility from "src/Components/utils/Visibility";
import { userTypes } from "src/enums/usersTpes";

function Menus() {
  const { menus, menusLoading } = indexStore();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full gap-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <UtensilsCrossed className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("dashbord.menus")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_menus_desc") || "Manage and organize your restaurant menus"}
            </p>
          </div>
        </div>
        <Visibility
          visible={
            localStorage.getItem("role") === userTypes.ADMIN ||
            localStorage.getItem("role") === userTypes.DATAMANAGER
          }
        >
          <AddMenuModel
            trigger={
              <Button className="gap-2">
                <Plus className="w-4 h-4" />
                <span className="hidden md:block">
                  {t("gloabl.add")} {t("gloabl.menu")}
                </span>
                <span className="md:hidden">{t("gloabl.add")}</span>
              </Button>
            }
          />
        </Visibility>
      </div>

      {/* Menus Grid */}
      <div className="flex-1">
        <Visibility visible={menusLoading}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            <Iterator
              data={[1, 2, 3, 4]}
              render={(row) => <MenuCardLoading key={row} />}
            />
          </div>
        </Visibility>
        <Visibility visible={!menusLoading}>
          {menus.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <Iterator data={menus} render={(row) => <MenuCard key={row.id} {...row} />} />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
              <UtensilsCrossed className="w-16 h-16 mb-4 text-gray-300" />
              <p className="text-xl font-semibold mb-2">{t("gloabl.no_menus_found") || "No menus found"}</p>
              <p className="mb-4">{t("gloabl.menus_will_appear") || "Menus will appear here once you add them"}</p>
              <Visibility
                visible={
                  localStorage.getItem("role") === userTypes.ADMIN ||
                  localStorage.getItem("role") === userTypes.DATAMANAGER
                }
              >
                <AddMenuModel
                  trigger={
                    <Button variant="outline" className="gap-2">
                      <Plus className="w-4 h-4" />
                      {t("gloabl.add")} {t("gloabl.menu")}
                    </Button>
                  }
                />
              </Visibility>
            </div>
          )}
        </Visibility>
      </div>
    </div>
  );
}

export default Menus;
